import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ggi-19",
  "use": "icon-ggi-19-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ggi-19\">\n<rect x=\"17\" y=\"4\" width=\"16\" height=\"10\" rx=\"1\" transform=\"rotate(90 17 4)\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" />\n<rect x=\"14\" y=\"6\" width=\"2\" height=\"4\" rx=\"1\" transform=\"rotate(90 14 6)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol